<!-- eslint-disable vue/no-v-html -->
<template>
  <!-- 컨펌 모달 -->
  <div class="modal-wrapper terms-modal" :class="{ 'is-show': isShowModal }">
    <div class="header">
      <header class="bdb-header">
        <div class="header_inner">
          <div
            class="hd-logo"
            :class="{ 'is-close': isShowModal }"
            @click="$emit('close')"
          >
            <i class="icon icon-hd-arrow" />
          </div>
          <p class="hd-ttl f-s f-bk">약관정보</p>
        </div>
      </header>
    </div>
    <div class="dialog-modal modal type-terms">
      <div class="modal-wrap">
        <div class="dialog-content modal-cont is-show">
          <div class="terms-section">
            <div class="btn-grp">
              <button
                class="btn btn-half btn-terms f-b"
                type="button"
                :class="{ 'is-active': termsTab === 1 }"
                @click="termsTab = 1"
              >
                이용 약관
              </button>
              <button
                class="btn btn-half btn-terms f-b"
                type="button"
                :class="{ 'is-active': termsTab === 2 }"
                @click="termsTab = 2"
              >
                개인정보처리방침
              </button>
            </div>
            <TermsContent :terms-tab="termsTab" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TermsModal",
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    tab: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      isShowModal: false,
      termsTab: 1,
    };
  },
  watch: {
    "$route.params.tab"(infoTab) {
      this.termsTab = parseInt(infoTab, 10);
    },
    isShow(val) {
      this.isShowModal = val;
      if (val) {
        this.termsTab = this.tab;
      }
    },
    tab(val) {
      this.termsTab = val;
    },
  },
};
</script>

<style scoped></style>
